import { purify } from "../_src/components/purify";

export function searchNoticias() {
    var btnLoadMore = document.querySelector("[data-action=load-more]")

    function search(loadMore) {
        var form = document.querySelector('#filter-news');
        var data = new FormData(form);
        const page = loadMore ? btnLoadMore.dataset.page : "1"

        if (btnLoadMore?.classList.contains("hidden")) {
            btnLoadMore.classList.remove("hidden")
        }

        if (!loadMore) {
            document.querySelector("#result-news").innerHTML = ""
            document.querySelector(".loader-news").classList.remove("hidden")
        }

        document.querySelector("#term").parentNode.classList.add("loading")
        btnLoadMore?.classList.add("loading")

        document.querySelectorAll("#filter-news fieldset").forEach(function(el) {
            el.classList.add("disabled")
        })

        fetch(`/noticias/ajax/news.html/p${page}?&loadmore=${loadMore}`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector("#load-more-news").insertAdjacentHTML('beforebegin', response);

                if (document.querySelector("#result-not-found")) {
                    btnLoadMore?.classList.add("hidden")
                    document.querySelector("#result-not-found").remove()
                } else {
                    btnLoadMore?.classList.remove("hidden")
                }
            } else {
                document.querySelector("#result-news").innerHTML = purify(response);

                searchNoticias();
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            btnLoadMore?.classList.remove("loading")

            if (!loadMore) {
                document.querySelector(".loader-news").classList.add("hidden")
            }

            if (btnLoadMore && parseInt(btnLoadMore.dataset.page) > parseInt(btnLoadMore.dataset.total)) {
                btnLoadMore.classList.add("hidden")
            }

            document.querySelector("#term").parentNode.classList.remove("loading")

            document.querySelectorAll("#filter-news fieldset").forEach(function(el) {
                el.classList.remove("disabled")
            })
        });
    }

    if(btnLoadMore) {
        btnLoadMore.addEventListener("click", function() { 
            search(true);
            if(btnLoadMore) {
                btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1
            }
        }, false);
    }

    document.querySelector("#filter-news").addEventListener("submit", function(event) { 
        event.preventDefault();
        search(false);
        if(btnLoadMore) {
            btnLoadMore.dataset.page = "2" 
        }
    }, false);

   const btnClear = document.querySelector('#filter-news [data-action=clear-search]')
    if (btnClear) {
        btnClear.disabled = true;
        const termInput = document.querySelector('#filter-news input[name="term"]');

        function updateClearBtnNews() {
            const hasText = termInput && termInput.value.trim().length > 0;
            const hasActiveFilter = document.querySelector('#data').value !== "";
            btnClear.disabled = !(hasText || hasActiveFilter);
        }
        
        btnClear.addEventListener("click", function () {
            if (termInput) termInput.value = "";
            document.querySelector('#data').value = "";
            document.querySelector("#result-news").innerHTML = "";
            document.querySelector(".loader-news").classList.remove("hidden");
            updateClearBtnNews();

            if(btnLoadMore) btnLoadMore.dataset.page = "1";
            search(false);
        });

        if (termInput) termInput.addEventListener("input", updateClearBtnNews);
        updateClearBtnNews();
    }
}

if (document.querySelector("#filter-news")) {
    searchNoticias();
}